import presentationModules from './presentation/index'

export default {
  ...presentationModules,
}
